import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import T from '../styles/theme';
import Icon from './Icon';

/**
 * CompanyContactPicker — modal that lists a filtered set of contacts and lets
 * the user pick one for a follow-up action. Used by CompanyRecord's Call
 * quick-action to resolve which person to log the call against.
 */
export default function CompanyContactPicker({ isOpen, onClose, contacts, onSelect, title }) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const list = Array.isArray(contacts) ? contacts : [];

  return ReactDOM.createPortal(
    <div onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()}
        style={{ width: 420, maxWidth: "92vw", maxHeight: "70vh", background: "#2C2E33", border: "1px solid " + T.bdr, borderRadius: 10, padding: 20, display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 400, color: T.txt }}>{title || "Pick a contact"}</div>
          <button onClick={onClose}
            style={{ width: 24, height: 24, borderRadius: 6, background: "rgba(255,255,255,0.08)", border: "1px solid " + T.bdr, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: T.tx3, fontFamily: "inherit" }}>×</button>
        </div>

        <div style={{ flex: 1, overflowY: "auto", marginBottom: 4 }}>
          {list.length === 0 ? (
            <div style={{ fontSize: 11, color: T.tx3, padding: "20px 0", textAlign: "center" }}>No contacts available</div>
          ) : list.map(ct => (
            <button key={ct.id}
              onClick={() => { onSelect?.(ct); onClose?.(); }}
              style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", padding: "10px 12px", marginBottom: 4, fontSize: 12, color: T.txt, background: "rgba(255,255,255,0.04)", border: "1px solid " + T.bdr, borderRadius: 6, cursor: "pointer", fontFamily: "inherit" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(217,219,221,0.28)"}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.bdr}>
              <div style={{ width: 28, height: 28, borderRadius: 14, background: "rgba(255,255,255,0.06)", border: "1px solid " + T.bdr, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="user" size={12} color={T.tx3} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 400, color: T.txt }}>{ct.fn} {ct.ln}</div>
                {ct.title && <div style={{ fontSize: 10, color: T.tx3, marginTop: 1 }}>{ct.title}</div>}
                {ct.ph && <div style={{ fontSize: 10, color: T.txt, marginTop: 2 }}>{ct.ph}</div>}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}
